import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

import { fontStyle } from '../../../../theme/helpers/fontStyle';

export const ActorInformationItem = styled.li<{ isFluid?: boolean }>`
  &:not(:last-child) {
    margin-bottom: ${spacing('lg')};
  }
  width: ${({ isFluid }) => (isFluid ? '100%' : 'auto')};
`;

export const ActorInformationList = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
`;

export const $NoteContainer = styled.div`
  ${fontStyle('sm')};
`;
